const PaymentInitComponent = () => import("@/views/payment/paymentInit.vue");
const PaymentVerifyComponent = () =>
    import("@/views/payment/paymentVerify.vue");

export default {
    path: "payment",
    meta: { label: "Payment" },
    component: {
        render(c) {
            return c("router-view");
        },
    },
    children: [
        {
            path: "",
            meta: {
                requiresAuth: true,
            },
            component: {
                render(c) {
                    return c("router-view");
                },
            },
            children: [
                {
                    path: "init/:id",
                    name: "Payment Init",
                    meta: {
                        hideLayout: true,
                    },
                    component: PaymentInitComponent,
                },
                {
                    path: "verify/:id",
                    meta: {
                        hideLayout: true,
                    },
                    component: PaymentVerifyComponent,
                },
            ],
        },
    ],
};
